export default {
  editTitle: 'Editar Plano',
  newTitle: 'Novo Plano',
  save: 'Salvar',
  create: 'Criar',
  name: 'Nome',
  startDate: 'Data de início',
  endDate: 'Data de fim',
  weekly: 'Semanal',
  weeklyDisabledForTemplate: 'A frequência está fixada na granularidade dos dados do template.',
  weekDefinition: 'Definição de Semana',
  weekDefinitionInfo1: 'As semanas começam às segundas-feiras.',
  weekDefinitionInfo2: 'As semanas são representadas pela data de seu último dia (domingo).',
  weekDefinitionInfo3: 'Mesmo que apenas um dia de uma determinada semana esteja compreendido entre a Data de Início e a Data de Fim, essa semana será considerada no plano.',
  weekDefinitionInfo4: 'Por isso, quando a sua Data de Fim cai no meio da semana, a última coluna leva uma data posterior: é o domingo em que termina a semana à qual a sua Data de Fim pertence.',
  ok: 'Ok',
  nameRequired: 'O nome é obrigatório',
  dateRequired: 'A data é obrigatória',
  mustBeAfterStartDate: 'Deve ser posterior à data de início'
}
